import styled from 'styled-components';
// import { Button } from '@chakra-ui/react';

export const ProfileButton = styled.div`
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    margin-left: 16px;
  }
  div {
    font-weight: 700;
    font-size: 14px;
  }
`;

export const PageTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  margin-left: 14px;

  display: flex;
  align-items: center;
`;
